import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/careers',
    name: 'careers',
    component: () => import(/* webpackChunkName: "careers" */ './views/Careers.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue')
  },
  {
    path: '/policies',
    name: 'policies',
    component: () => import(/* webpackChunkName: "policies" */ './views/Policies.vue')
  },
  {
    path: '/brands/the-coffee-club',
    name: 'coffeeclub',
    component: () => import(/* webpackChunkName: "coffeeclub" */ './views/CoffeeClub.vue')
  },
  {
    path: '/brands/coffee-hit',
    name: 'coffeehit',
    component: () => import(/* webpackChunkName: "coffeehit" */ './views/CoffeeHit.vue')
  },
  {
    path: '/brands/veneziano',
    name: 'veneziano',
    component: () => import(/* webpackChunkName: "veneziano" */ './views/Veneziano.vue')
  },
  {
    path: '/brands/three-stories',
    name: 'threestories',
    component: () => import(/* webpackChunkName: "threestories" */ './views/ThreeStories.vue')
  }
]

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
